<template>
    <div class="tab-content">
        <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

            <el-tab-pane :disabled="!projectPermission.viewTaskDetail" :label="$t('project_tab_info_detail')" name="first">
                <el-card v-if="selectedRow.type === 'task'" class="box-card card panel">

                    <el-row :gutter="20" class="info-title-color">
                        <el-col :span="11">
                            <div class="title">{{$t('project_tab_info_detail_task')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdBy')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.creatorCompanyUser.id)" v-if="taskInfo.creatorCompanyUser">{{taskInfo.creatorCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_task')}}:
                                </el-col>
                                <el-col :span="15">
                                    <el-row class="info-color">
                                        <el-col :span="24">
                                            <strong>{{taskInfo.name}}</strong>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <!-- <div class="title_disabled">Billing</div>

                            <el-row style="margin-bottom: 5px; color: #ccc;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    Progress Billing Set:
                                </el-col>
                                <el-col :span="15">
                                    <el-row style="color: #ccc;">
                                        <el-col :span="24">
                                            <span>No</span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row> -->


                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_dates')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdOn')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span >{{moment(taskInfo.createDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_planned')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    {{moment(taskInfo.startDate).format("D MMM YY, h:mm a")}}
                                    {{$t('project_tab_info_detail_to')}} {{moment(taskInfo.deadlineDate).format("D MMM YY, h:mm a")}}
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <span v-if="taskInfo.startedDate && !taskInfo.endedDate">{{$t('project_tab_info_detail_actual_start_date')}}</span>
                                    <span v-else>{{$t('project_tab_info_detail_actual')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.startedDate">{{moment(taskInfo.startedDate * 1000).format("D MMM YY")}}</span>
                                    <span v-if="taskInfo.endedDate"> {{$t('project_tab_info_detail_to')}} {{moment(taskInfo.endedDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_documents')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_taskDocumentsAdded')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.addTaskDocument">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Sop" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_SOP')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Sop.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Policy" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_policy')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Policy.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.HealthSafety" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_healthSafety')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.HealthSafety.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Envirenmental" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_envirenmental')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Envirenmental.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.RiskAssesment" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_riskAssesment')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.RiskAssesment.name}}</span>
                                </el-col>
                            </el-row>

                            <!-- <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_assignedTo')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.leaderCompanyUser.id)" v-if="taskInfo.leaderCompanyUser">{{taskInfo.leaderCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row> -->

                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_notifications')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_clientVendorNotifications')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.allowExternalNotifications">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                        </el-col>
                        <el-col :span="13">
                            <!-- <div class="title" style="text-align: center;">PROGRESS</div> -->

                            <el-row type="flex" justify="end">
                                <el-col :span="8">
                                    <br>
                                    <el-row>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Phase</div>
                                            <el-tooltip class="item" effect="dark" content="Phase" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.companyStage.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Status</div>
                                            <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" :type="taskStatusStyle" style="width:130px; text-align: center;" v-html="taskStatusName"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24">
                                            <div style="margin-left: 45px;">Priority</div>
                                            <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.priority.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="8" v-if="selectedRow.type === 'task'">
                                    <div class="title">{{$t('project_tab_info_detail_progress')}}</div>

                                    <el-progress type="dashboard" :percentage="Math.round(taskInfo.progress)" :color="colors"></el-progress>
                                </el-col>
                                <el-col :span="8">
                                    <br>
                                    <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <div class="panel__footer">
                        <div class="panel__first">

                            <el-row :gutter="20" style="margin-bottom: 0px;">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('project_tab_info_detail_taskTeam')}}:</div>
                                            <!-- {{$t('project_tab_info_detail_taskTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item">
                                            <ul style="padding-left:0; margin-top: 0;">
                                                <li style="list-style-type: none;" v-for="item in projectTaskCompanyUserList" :key="item.id">
                                                    <el-tooltip placement="top">
                                                        <div slot="content">
                                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                        </div>
                                                        <div>
                                                            <span @mouseenter="getUserInfo(item.companyUserId)">{{item.userFullName}}</span><br>
                                                        </div>
                                                    </el-tooltip>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title">{{$t('project_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" v-for="item in projectTaskCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_assignedTo')}}</div>
                                    <!-- {{$t('project_tab_info_detail_assignedTo')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.leaderCompanyUser.id)" v-if="taskInfo.leaderCompanyUser">{{taskInfo.leaderCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </div>
                            </div>

                            <el-row :gutter="20" style="margin-bottom: 0px;">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title" style="padding-top: 20px;">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('project_tab_info_detail_managementTeam')}}:</div>
                                            <!-- {{$t('project_tab_info_detail_managementTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in projectCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title" style="padding-top: 20px;">{{$t('project_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" v-for="item in projectCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                        </div>
                        <div class="panel__second">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_sharedTeam')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_sharedTeam')}}: -->
                                </i>
                            </div>
                            <div class="panel__team_item">
                                <ul style="padding-left:0; margin-top: 0;">
                                    <li style="list-style-type: none;" v-for="item in sharedProjectTaskTeamCompanyUserList" :key="item.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                            </div>
                                            <div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)">{{item.userFullName}}</span><br>
                                                <span style="font-size:14px;">[{{item.companyUser.name}}]</span>
                                            </div>
                                        </el-tooltip>
                                    </li>
                                </ul>
                            </div>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/share_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_sharedWith')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_sharedWith')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" >
                                    <ul style="padding-left:0; margin-top: 0;">
                                        <li style="list-style-type: none;" v-for="item in sharedProjectTaskCompanyUserList" :key="item.id"><span v-html="item.sharedCompanyUser.user.fullName"></span><br><span style="font-size:13px; line-height: 1.1;">[{{item.sharedCompanyUser.company.name}}]</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/waiting.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_waiting')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_waiting')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <ul style="padding-left:0; margin-top: 0;">
                                        <li style="list-style-type: none;" v-for="item in tempSharedProjectTaskCompanyUserList" :key="item.id"><span v-html="item.sharedCompanyUser.user.fullName"></span><br><span style="font-size:13px; line-height: 1.1;">[{{item.sharedCompanyUser.company.name}}]</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="panel__third">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_taskClients')}}:</div>
                                    <!-- {{$t('project_tab_info_taskClients')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newClientList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: <a :href="item.facebook" target="_blank">{{item.facebook}}</a><br/></span>
                                            <span v-if="item.linkedin">Linkedin: <a :href="item.linkedin" target="_blank">{{item.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyClientPerson.fullName">Name: {{person.companyClientPerson.fullName}}<br/></span>
                                                <span v-if="person.companyClientPerson.mobilePhone">Phone: {{person.companyClientPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyClientPerson.address">Location: {{person.companyClientPerson.address}}<br/></span>
                                                <span v-if="person.companyClientPerson.email">Email: {{person.companyClientPerson.email}}<br/></span>
                                                <span v-if="person.companyClientPerson.skype">Skype: {{person.companyClientPerson.skype}}<br/></span>
                                                <span v-if="person.companyClientPerson.facebook">Facebook: <a :href="person.companyClientPerson.facebook" target="_blank">{{person.companyClientPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyClientPerson.linkedin">LinkedIn: <a :href="person.companyClientPerson.linkedin" target="_blank">{{person.companyClientPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyClientPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="panel__team_title" style="padding-top: 25px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_taskVendors')}}:</div>
                                    <!-- {{$t('project_tab_info_taskVendors')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newVendorList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: <a :href="item.facebook" target="_blank">{{item.facebook}}</a><br/></span>
                                            <span v-if="item.linkedin"><a :href="item.linkedin" target="_blank">Linkedin: {{item.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyVendorPerson.fullName">Name: {{person.companyVendorPerson.fullName}}<br/></span>
                                                <span v-if="person.companyVendorPerson.mobilePhone">Mobile Phone: {{person.companyVendorPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.workPhone">Work Phone: {{person.companyVendorPerson.workPhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.address">Location: {{person.companyVendorPerson.address}}<br/></span>
                                                <span v-if="person.companyVendorPerson.email">Email: {{person.companyVendorPerson.email}}<br/></span>
                                                <span v-if="person.companyVendorPerson.skype">Skype: {{person.companyVendorPerson.skype}}<br/></span>
                                                <span v-if="person.companyVendorPerson.facebook">Facebook: <a :href="person.companyVendorPerson.facebook" target="_blank">{{person.companyVendorPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyVendorPerson.linkedin">LinkedIn: <a :href="person.companyVendorPerson.linkedin" target="_blank">{{person.companyVendorPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyVendorPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-card>

                <el-card v-if="selectedRow.type === 'masterTask'" class="box-card card panel">

                    <el-row :gutter="20" class="info-title-color">
                        <el-col :span="11">
                            <div class="title">{{$t('project_tab_info_detail_task')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdBy')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.creatorCompanyUser.id)" v-if="taskInfo.creatorCompanyUser">{{taskInfo.creatorCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_task')}}:
                                </el-col>
                                <el-col :span="15">
                                    <el-row class="info-color">
                                        <el-col :span="24">
                                            <strong>{{taskInfo.name}}</strong>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_dates')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdOn')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span >{{moment(taskInfo.createDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_planned')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    {{moment(taskInfo.startDate).format("D MMM YY")}}
                                    {{$t('project_tab_info_detail_to')}} {{moment(taskInfo.deadlineDate).format("D MMM YY")}}
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <span v-if="taskInfo.startedDate && !taskInfo.endedDate">{{$t('project_tab_info_detail_actual_start_date')}}</span>
                                    <span v-else>{{$t('project_tab_info_detail_actual')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.startedDate">{{moment(taskInfo.startedDate * 1000).format("D MMM YY")}}</span>
                                    <span v-if="taskInfo.endedDate"> {{$t('project_tab_info_detail_to')}} {{moment(taskInfo.endedDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_documents')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_taskDocumentsAdded')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.addTaskDocument">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Sop" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_SOP')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Sop.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Policy" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_policy')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Policy.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.HealthSafety" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_healthSafety')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.HealthSafety.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Envirenmental" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_envirenmental')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Envirenmental.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.RiskAssesment" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_riskAssesment')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.RiskAssesment.name}}</span>
                                </el-col>
                            </el-row>

                            <!-- <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_assignedTo')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.leaderCompanyUser.id)" v-if="taskInfo.leaderCompanyUser">{{taskInfo.leaderCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row> -->

                            <el-divider></el-divider>

                            <div class="title">{{$t('project_tab_info_detail_notifications')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_clientVendorNotifications')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.allowExternalNotifications">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                        </el-col>
                        <el-col :span="13">
                            <!-- <div class="title" style="text-align: center;">PROGRESS</div> -->

                            <el-row type="flex" justify="end">
                                <el-col :span="8">
                                    <br>
                                    <el-row>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Phase</div>
                                            <el-tooltip class="item" effect="dark" content="Phase" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.companyStage.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Status</div>
                                            <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" :type="taskStatusStyle" style="width:130px; text-align: center;" v-html="taskStatusName"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24">
                                            <div style="margin-left: 45px;">Priority</div>
                                            <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.priority.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="8">
                                    <div class="title">{{$t('project_tab_info_detail_progress')}}</div>

                                    <el-progress v-if="selectedRow.type === 'task'" type="dashboard" :percentage="Math.round(taskInfo.progress)" :color="colors"></el-progress>
                                    <div style="margin-bottom: 15px;">
                                        <!-- <div class="circle">
                                            <div class="circle_number">{{taskInfo.doneChildTasksCount}}/{{taskInfo.childTasksCount}}</div>
                                        </div> Done/Sub Task -->

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.childTasksCount}} - {{$t('general_subTask')}}</el-col>
                                        </el-row>

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.fullProgressTasksCount}} - 100%</el-col>
                                        </el-row>

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.doneChildTasksCount}} - {{$t('general_done')}}</el-col>
                                        </el-row>

                                        <!-- <div>{{$t('general_done')}} ({{taskInfo.doneChildTasksCount}}) / {{$t('general_subTask')}} ({{taskInfo.childTasksCount}})</div> -->
                                    </div>
                                    <div>
                                        <!-- <div class="circle">
                                            <div class="circle_number">{{taskInfo.fullProgressTasksCount}}/{{taskInfo.childTasksCount}}</div>
                                        </div> 100%/Sub Task -->

                                        <!-- <div>100% ({{taskInfo.fullProgressTasksCount}}) / {{$t('general_subTask')}} ({{taskInfo.childTasksCount}})</div> -->
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <br>
                                    <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <div class="panel__footer">
                        <div class="panel__first">

                            <el-row :gutter="20" style="margin-bottom: 0px;">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('project_tab_info_detail_taskTeam')}}:</div>
                                            <!-- {{$t('project_tab_info_detail_taskTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item">
                                            <ul style="padding-left:0; margin-top: 0;">
                                                <li style="list-style-type: none;" v-for="item in projectTaskCompanyUserList" :key="item.id">
                                                    <el-tooltip placement="top">
                                                        <div slot="content">
                                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                        </div>
                                                        <div>
                                                            <span @mouseenter="getUserInfo(item.companyUserId)">{{item.userFullName}}</span><br>
                                                        </div>
                                                    </el-tooltip>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title">{{$t('project_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" v-for="item in projectTaskCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_assignedTo')}}</div>
                                    <!-- {{$t('project_tab_info_detail_assignedTo')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" @mouseenter="getUserInfo(taskInfo.leaderCompanyUser.id)" v-if="taskInfo.leaderCompanyUser">{{taskInfo.leaderCompanyUser.user.fullName}}</span>
                                    </el-tooltip>
                                </div>
                            </div>

                            <el-row :gutter="20">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title" style="padding-top: 20px;">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('project_tab_info_detail_managementTeam')}}:</div>
                                            <!-- {{$t('project_tab_info_detail_managementTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in projectCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title" style="padding-top: 20px;">{{$t('project_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" v-for="item in projectCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                        </div>
                        <div class="panel__second">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_sharedTeam')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_sharedTeam')}}: -->
                                </i>
                            </div>
                            <div class="panel__team_item">
                                <ul style="padding-left:0; margin-top: 0;">
                                    <li style="list-style-type: none;" v-for="item in sharedProjectTaskTeamCompanyUserList" :key="item.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                            </div>
                                            <div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)">{{item.userFullName}}</span><br>
                                                <span style="font-size:14px;">[{{item.companyUser.name}}]</span>
                                            </div>
                                        </el-tooltip>
                                    </li>
                                </ul>
                            </div>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/share_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_sharedWith')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_sharedWith')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" >
                                    <ul style="padding-left:0; margin-top: 0;">
                                        <li style="list-style-type: none;" v-for="item in sharedProjectTaskCompanyUserList" :key="item.id"><span v-html="item.sharedCompanyUser.user.fullName"></span><br><span style="font-size:13px; line-height: 1.1;">[{{item.sharedCompanyUser.company.name}}]</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/waiting.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_waiting')}}:</div>
                                    <!-- {{$t('project_tab_info_detail_waiting')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <ul style="padding-left:0; margin-top: 0;">
                                        <li style="list-style-type: none;" v-for="item in tempSharedProjectTaskCompanyUserList" :key="item.id"><span v-html="item.sharedCompanyUser.user.fullName"></span><br><span style="font-size:13px; line-height: 1.1;">[{{item.sharedCompanyUser.company.name}}]</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="panel__third">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_taskClients')}}:</div>
                                    <!-- {{$t('project_tab_info_taskClients')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newClientList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: <a :href="item.facebook" target="_blank">{{item.facebook}}</a><br/></span>
                                            <span v-if="item.linkedin">Linkedin: <a :href="item.linkedin" target="_blank">{{item.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyClientPerson.fullName">Name: {{person.companyClientPerson.fullName}}<br/></span>
                                                <span v-if="person.companyClientPerson.mobilePhone">Phone: {{person.companyClientPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyClientPerson.address">Location: {{person.companyClientPerson.address}}<br/></span>
                                                <span v-if="person.companyClientPerson.email">Email: {{person.companyClientPerson.email}}<br/></span>
                                                <span v-if="person.companyClientPerson.skype">Skype: {{person.companyClientPerson.skype}}<br/></span>
                                                <span v-if="person.companyClientPerson.facebook">Facebook: <a :href="person.companyClientPerson.facebook" target="_blank">{{person.companyClientPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyClientPerson.linkedin">LinkedIn: <a :href="person.companyClientPerson.linkedin" target="_blank">{{person.companyClientPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyClientPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="panel__team_title" style="padding-top: 25px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_taskVendors')}}:</div>
                                    <!-- {{$t('project_tab_info_taskVendors')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newVendorList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: <a :href="item.facebook" target="_blank">{{item.facebook}}</a><br/></span>
                                            <span v-if="item.linkedin"><a :href="item.linkedin" target="_blank">Linkedin: {{item.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyVendorPerson.fullName">Name: {{person.companyVendorPerson.fullName}}<br/></span>
                                                <span v-if="person.companyVendorPerson.mobilePhone">Mobile Phone: {{person.companyVendorPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.workPhone">Work Phone: {{person.companyVendorPerson.workPhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.address">Location: {{person.companyVendorPerson.address}}<br/></span>
                                                <span v-if="person.companyVendorPerson.email">Email: {{person.companyVendorPerson.email}}<br/></span>
                                                <span v-if="person.companyVendorPerson.skype">Skype: {{person.companyVendorPerson.skype}}<br/></span>
                                                <span v-if="person.companyVendorPerson.facebook">Facebook: <a :href="person.companyVendorPerson.facebook" target="_blank">{{person.companyVendorPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyVendorPerson.linkedin">LinkedIn: <a :href="person.companyVendorPerson.linkedin" target="_blank">{{person.companyVendorPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyVendorPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-card>
            </el-tab-pane>

            <!-- about -->
            <el-tab-pane :disabled="!projectPermission.viewTaskAbout" :label="$t('project_tab_info_about')" name="about">
                <el-card class="box-card card panel">
                    <!-- <div v-html="!taskInfo.description ? emtyDescription : taskInfo.description"></div> -->
                    <aboutTask/>
                </el-card>
                <!-- (About) -->
            </el-tab-pane>

            <!-- to do -->
            <el-tab-pane :disabled="!projectPermission.viewTaskToDo" :label="$t('project_tab_info_toDo')" name="toDo">
                <el-card class="box-card card panel">
                    <!-- Current Service Under Development -->
                    <toDo/>
                </el-card>
                <!-- (To Do) -->
            </el-tab-pane>

            <!-- progress -->
            <el-tab-pane :disabled="!projectPermission.viewProgressNotes" v-if="selectedRow.type === 'task'" :label="$t('project_tab_progress')" name="progress" id="taskTab">
                <el-card class="box-card card panel">
                    <projProgressTab
                          ref="projProgressTab"
                          :stateId="stateId"
                          :projectPermission="projectPermission"
                          :sharedProjecttaskNoteId="sharedProjecttaskNoteId"
                          :selectedRow="selectedRow"
                          :progressData="progressData"
                          :selectedTaskForInfo="selectedTaskForInfo"
                          :selectedRowId="selectedRow.id"
                          :activeProjectId="activeProjectId"
                          @submit="getProjects"/>
                </el-card>
            </el-tab-pane>

            <!-- documents -->
            <el-tab-pane :disabled="!projectPermission.viewDocuments" v-if="selectedRow.type === 'task' || selectedRow.type === 'masterTask'" :label="$t('project_tab_documents')" name="documents">
                <DocumentsTask ref="docs" :projectPermission="projectPermission" :selectedRow="selectedRow"/>
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.viewTaskHistory" :label="$t('project_tab_info_history')" name="five">
                <projectTaskHistory/>
            </el-tab-pane>

        </el-tabs>

<!--        <div class="book-mark-block pointer">-->
<!--            <div v-if="bookmarkList.info" @click="changeBookMark(bookmarkList.info, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--            <div v-else @click="changeBookMark(bookmarkList.info, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--        </div>-->
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import axios from 'axios';
  import projectTaskHistory from '@/components/Projects/projectTaskHistoryTab.vue'
  import projProgressTab from '@/components/Projects/projProgressTab.vue'
  import DocumentsTask from '@/components/Projects/DocumentsTask.vue'
  import toDo from '@/components/Projects/toDo/toDo.vue'
  import aboutTask from '@/components/Projects/about/aboutTask.vue'

  export default  {
    name: 'info-project-task-tab',
    beforeMount() {

    },
    mounted(){

    },
    components: {
      projectTaskHistory,
      projProgressTab,
      DocumentsTask,
      toDo,
      aboutTask,
    },
    props: [
      'value',
      'selectedRow',
      'activeTaskInfoTab',
      // 'bookmarkList',
      'taskInfo',
      'projectPermission',
      'sharedProjecttaskNoteId',
      'progressData',
      'selectedTaskForInfo',
      'selectedRowId',
      'activeProjectId'
    ],
    computed: {
      ...mapGetters([
        'getStateId'
      ])
    },
    watch: {
      // 'taskInfo.status': function (val) {
      //   alert(val)
      //   switch(this.taskInfo.status) {
      //     case 1:
      //       this.taskStatusName = 'Created';
      //       this.taskStatusStyle = 'info';
      //       break;
      //     case 2:
      //       if ((Math.round(this.taskInfo.progress) > 0)) {
      //         this.taskStatusName = 'In Progress'
      //       } else {
      //         this.taskStatusName = 'Started'
      //       }
      //       this.taskStatusStyle = 'warning';
      //       break;
      //     case 3:
      //       this.taskStatusName = ' On Hold';
      //       this.taskStatusStyle = 'danger';
      //       break;
      //     case 4:
      //       this.taskStatusName = 'Done';
      //       this.taskStatusStyle = 'success';
      //       break;
      //     case 5:
      //       this.taskStatusName = 'In Progress';
      //       this.taskStatusStyle = 'warning';
      //       break
      //   }
      // },
      taskInfo: function (val) {
        this.projectCompanyUserList = this.taskInfo.projectCompanyUserList;
        this.projectTaskCompanyUserList = this.taskInfo.projectTaskCompanyUserList.filter(val => val.companyUser.id === this.taskInfo.companyId );
        this.sharedProjectTaskTeamCompanyUserList = this.taskInfo.projectTaskCompanyUserList.filter(val => val.companyUser.id !== this.taskInfo.companyId );
        this.projectTaskCompanyClientList = this.taskInfo.projectTaskCompanyClientList;
        this.projectTaskCompanyVendorList = this.taskInfo.projectTaskCompanyVendorList;
        this.projectTaskCompanyClientPersonList = this.taskInfo.projectTaskCompanyClientPersonList;
        this.projectTaskCompanyVendorPersonList = this.taskInfo.projectTaskCompanyVendorPersonList;
        this.sharedProjectTaskCompanyUserList = this.checkSharedUsers(this.taskInfo.sharedProjectTaskCompanyUserList, this.sharedProjectTaskTeamCompanyUserList);
        this.tempSharedProjectTaskCompanyUserList = this.taskInfo.tempSharedProjectTaskCompanyUserList;

        this.newVendorList = this.createMyList(this.taskInfo.projectTaskCompanyVendorList, this.taskInfo.projectTaskCompanyVendorPersonList, 'vendor');
        this.newClientList = this.createMyList(this.taskInfo.projectTaskCompanyClientList, this.taskInfo.projectTaskCompanyClientPersonList, 'clients');

        let start = this.taskInfo.startDate;
        let end = this.taskInfo.deadlineDate;

        if (start.toString().length < 8) {
          start = '0' + start.toString()
        } else {
          start = start.toString()
        }
        if (end.toString().length < 8) {
          end = '0' + end.toString()
        } else {
          end = end.toString()
        }

        start = moment(start, 'DDMMYYYY');
        end = moment(end, 'DDMMYYYY');
        this.plannedDaysTask = moment.duration(end.diff(start)).asDays();
        if (this.plannedDaysTask == 0) {
          this.plannedDaysTask = 1
        }

        // remove from top start
        switch(val.status) {
          case 1:
            this.taskStatusName = 'Created';
            this.taskStatusStyle = 'info';
            break;
          case 2:
            if ((Math.round(val.progress) > 0)) {
              this.taskStatusName = 'In Progress'
            } else {
              this.taskStatusName = 'Started'
            }
            this.taskStatusStyle = 'warning';
            break;
          case 3:
            this.taskStatusName = ' On Hold';
            this.taskStatusStyle = 'danger';
            break;
          case 4:
            this.taskStatusName = 'Done';
            this.taskStatusStyle = 'success';
            break;
          case 5:
            this.taskStatusName = 'In Progress';
            this.taskStatusStyle = 'warning';
            break
        }
        // remove from top end
      },
    },
    data() {
      return {
        newVendorList:[],
        newClientList:[],
        tooltipUser: {},
        plannedDaysTask: null,
        // Project
        projectCompanyUserList: null,
        // Task
        projectTaskCompanyUserList: null,
        sharedProjectTaskTeamCompanyUserList: null,
        projectTaskCompanyClientList: null,
        projectTaskCompanyVendorList: null,
        projectTaskCompanyClientPersonList: null,
        projectTaskCompanyVendorPersonList: null,
        sharedProjectTaskCompanyUserList: null,
        tempSharedProjectTaskCompanyUserList: null,
        taskStatusStyle: null,
        moment:moment,
        taskStatusName: '',
        emtyDescription: this.$i18n.t('noDetailsProvided'),
        colors: [
          {color: '#e67112', percentage: 25},
          {color: '#63B8FF', percentage: 51},
          {color: '#63B8FF', percentage: 76},
          {color: '#0fd641 ', percentage: 100}
        ],
        stateId: null
      }
    },
    methods:{
      // setActiveStateId(stateId) {
      //   this.stateId = stateId;
      // },
      getProjects(projectId, state, newCreatedProjectTask){
        // alert(this.selectedRowId)
        this.$emit('getProjects', projectId, state, newCreatedProjectTask)
      },
      getUserInfo(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projects/fieldInfo?companyId=${this.$route.query.companyId}&field=companyUser&companyUserId=${id}`)
          .then(response => {
            console.log('hello2131231', response.data)
            this.tooltipUser = response.data.fieldInfo.user
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // changeBookMark(state, companyid, projectId, taskId){
      //   // data.info = state
      //   let data = this.bookmarkList
      //   data.info = !this.bookmarkList.info
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
      //     .then(response => {
      //       if (this.bookmarkList.info) {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
      //       } else {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
      //       }
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      createMyList(list, personList, state) {
        const myList = [];

        for (let i = 0; i < list.length; i++) {
          myList.push({ ...list[i], people: [] });
          if(state === 'vendor'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].id === personList[j].companyVendorPerson.companyVendorId) {
                myList[i].people.push(personList[j])
              }
            }
          }
          if(state === 'clients'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].id === personList[j].companyClientPerson.companyClientId) {
                myList[i].people.push(personList[j])
              }
            }
          }
        }
        return myList
      },
      handleClick(tab, event) {
        // detail
        if(tab.name === "first"){
          this.$emit('submit')
        }

        // about
        if(tab.name === "about"){
          this.$emit('submitAbout')
        }
        if(tab.name === "five"){
          this.$store.dispatch('getProjectTaskHistory')
        }

        if(tab.name === "progress"){
            this.$store.dispatch('getProgressesList', {'taskId': this.selectedRow.id, 'projectId': this.activeProjectId});
            //   .then(list => {
            //   if (list.length && this.getStateId) {
            //     const progressItem = list.filter(val => val.id === this.getStateId);
            //     if (progressItem) {
            //       this.$refs.projProgressTab.selectActiveProgressNode(this.getStateId);
            //     } else {
            //       this.$store.dispatch('setStateId', null)
            //     }
            //   }
            // });
            this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id})
        }

        if(tab.name === "documents"){
            this.$store.dispatch('getDocuments', this.selectedRow.id)
        }

        if(tab.name === "toDo"){
            this.$store.dispatch('toDo', 'project')
        }

        if(tab.name === "about"){
            this.$store.dispatch('about', 'projectTask')
        }
      },
      // getMaterialList() {
      //   let loader = this.$loading.show();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //     .post(`/api/v1/materials/directories?companyId=${this.$route.query.companyId}&taskId=${this.$route.query.taskId}&operation=create`)
      //     .then(response => {
      //       loader.hide()
      //     })
      //     .catch(error => {
      //       loader.hide();
      //       console.log('An error occurred:', error);
      //     });
      // },
      checkSharedUsers(sharedWith, assignedUsers){
        let sharedUsers = [];
        for (let i = 0; i < sharedWith.length; i++) {
          const user = this.compareFunction(sharedWith[i], assignedUsers);
          if (user){
            sharedUsers.push(user)
          }
        }
        return sharedUsers
      },
      compareFunction(user, assignedUsers){
        for (let i = 0; i < assignedUsers.length; i++) {
          if (user.sharedCompanyUser.id === assignedUsers[i].companyUserId) return false
        }
        return user
      }
    }
  }
</script>

<style lang="less" scoped>
    .days-block{
        margin-top:5px;
        span{
            font-weight:bold;
        }
    }
    .about-task{
        display:none;
    }
    .about-task.open{
        display:block;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        display:flex;
        align-items:center;
        font-weight:bold;
        padding:10px;
        font-size:14px;
        transition: .5s;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }

    .card {
        margin-bottom: 20px;
        .tag {
            margin-right: 5px;
        }
        &__no {
            display: flex;
            align-items: center;
            font-weight: bold;
            padding-bottom: 5px;
            .name {
                margin-right: 10px;
            }
            .progress {
                flex: 1;
            }
        }
        &__name {
            font-weight: bold;
            padding-bottom: 5px;
        }
        &__task-name {
            font-size: 18px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
        }
        &__location {
            padding-top: 5px;
            padding-bottom: 5px;
        }
        &__stat {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__by-to {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__btn {
            margin-left: 10px;
        }
    }

    .panel {
        min-width: 890px;
        margin-bottom: 20px;

        i.color {
            font-style: normal;
            color: #888;
        }

        // Header
        &__header {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #EBEEF5;
            padding-bottom: 10px;
        }

        &__project-name {
            span {font-weight: bold;}
        }
        &__task-name {
            font-weight: bold;
            font-size: 20px;
        }
        &__progress {
            display: flex;
            justify-content: flex-end;
            padding-bottom: 5px;
            .el-progress {
                width: 350px;
            }
        }
        &__status {
            display: flex;
            justify-content: flex-end;
        }

        // Info
        &__info {
            padding: 10px 0 5px 0;
            position: relative;
        }
        &__date {
            display: flex;
            margin-bottom: 5px;
        }
        &__planned {
            width: 300px;
            span {font-weight: bold;}
        }
        &__actual {
            span {font-weight: bold;}
            i {font-style: normal;}
        }
        &__by-to {
            display: flex;
            margin-bottom: 5px;
        }
        &__by {
            width: 300px;
            span {font-weight: bold;}
        }
        &__to {
            span {font-weight: bold;}
        }
        &__address {

        }
        &__priority {
            position: absolute;
            top: 35%;
            right: 0;
        }

        // Description
        &__description {
            position: relative;
            padding: 5px 0;
        }

        &__gif {
            position: absolute;
            top: 18px;
            left: 0;
        }

        // Footer
        &__footer {
            display: flex;
            justify-content: space-between;
            min-height: 150px;
            padding: 5px 0;
        }
        &__team {
            width: calc(100%/3);
            padding: 0 10px 0 0;
            border-right: 1px solid #EBEEF5;
            &_title {
                font-size: 16px;
            }
            &_item {
                cursor: pointer;
                // margin-left: 25px;
                line-height: 1.5;
                // color: #4277A6;
                color: black;
            }
        }
        &__clients {
            width: calc(100%/3);
            padding: 0 10px;
            border-right: 1px solid #EBEEF5;
            &_title {
                font-weight: bold;
            }
            &_item {
                cursor: pointer;
                margin-left: 22px;
            }
        }
        &__vendors {
            width: calc(100%/3);
            padding: 0 0 0 10px;
            &_title {
                font-weight: bold;
            }
            &_item {
                cursor: pointer;
                margin-left: 22px;
            }
        }

        &__first {
            width: 46%;
            padding: 0 10px 0 0;
            border-right: 1px solid #EBEEF5;
            &_title {
                font-size: 16px;
            }
            &_item {
                cursor: pointer;
                margin-left: 25px;
                line-height: 1.5;
                color: #4277A6;
            }
        }
        &__second {
            width: 27%;
            padding: 0 10px;
            border-right: 1px solid #EBEEF5;
            &_title {
                font-size: 16px;
            }
            &_item {
                cursor: pointer;
                margin-left: 25px;
                line-height: 1.5;
                color: #4277A6;
            }
        }
        &__third {
            width: 27%;
            padding: 0 0 0 10px;
            &_title {
                font-size: 16px;
            }
            &_item {
                cursor: pointer;
                margin-left: 25px;
                line-height: 1.5;
                color: #4277A6;
            }
        }
    }
    .pointer {
        cursor:pointer;
    }
    .vendor{
        font-weight:bold;
    }
</style>
<style lang="scss">
    .el-collapse-item__header {
        color: #888 !important;
        padding-left: 25px !important;
        font-size: 16px !important;
    }
    .el-collapse-item__content {
        color: #4277A6 !important;
        p {
            color: #4277A6 !important;
            font-size: 14px !important;
            padding-left: 25px !important;
            img {
                max-width: 100% !important;
            }
        }
    }

    .modal {
        color: #000;
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: right;
        }
    }

    // [ Modal ] end
    //.tab-content{
    //    position:relative;
    //    .book-mark-block{
    //        position:absolute;
    //        top:0;
    //        right:0;
    //        .el-checkbox__input{
    //            display:none;
    //        }
    //        .el-checkbox {
    //            border: none;
    //        }
    //        .el-checkbox__label{
    //            font-size:20px !important;
    //            color: #409EFF;
    //        }
    //    }
    //}

    .h-center {
        display: flex;
        align-items: center;
    }

    .info-title-color {
        // color: #888;
        color: black;
    }

    .info-color {
        // color: #4277A6;
        color: black;
    }
</style>

<style lang="scss">
    .el-divider--horizontal {
        margin: 14px 0 !important;
        background-color: #EBEEF5 !important;
    }

    p {
        img {
            max-width: 100%;
        }
    }

    .circle {
        position: relative;
        display: inline-block;
        top: 6px;
        margin: 0 auto;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 3px solid  #ddd;
        // background-color: #ddd;
    }
    .circle_number {
        position: absolute;
        top: 55%;
        width: 100%;
        line-height: 11px;
        margin-top: -0.38rem;
        text-align: center;
        font-size: 10px;
        color: #777;
    }
    .title {
        color: #409EFF;
        font-weight: 500;
        text-decoration: underline;
        margin-bottom: 5px;
        text-transform: uppercase;
    }

    .title_disabled {
        color: #ccc;
        font-weight: 500;
        text-decoration: underline;
        margin-bottom: 5px;
        // text-transform: uppercase;
    }
</style>
